import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';

import clsx from 'clsx';
import {useTranslation} from 'react-i18next';

import Typography from '@mui/material/Typography';

import {formatDate} from '../../Utilities/functions';

import {DRAWER_WIDTH} from '../Dashboard/Common/ProjectsDrawer';

const PREFIX = 'Footer';

const classes = {
  footer: `${PREFIX}-footer`,
  footerContainer: `${PREFIX}-footerContainer`,
  footerBtn: `${PREFIX}-footerBtn`,
  canadaLogo: `${PREFIX}-canadaLogo`,
  langBtnContainer: `${PREFIX}-langBtnContainer`,
  contentShift: `${PREFIX}-contentShift`
};

const Root = styled('footer')((
  {
    theme
  }
) => ({
  [`&.${classes.footer}`]: {
    height: 'auto',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'space-between',
    background: theme.palette.grey[100],
  },

  [`& .${classes.footerContainer}`]: {
    borderTop: '1px solid',
    borderTopColor: theme.palette.divider,
    margin: theme.spacing(0, 3, 0, 3),
    padding: theme.spacing(3, 0),
  },

  [`& .${classes.footerBtn}`]: {
    color: theme.palette.text.secondary,
    margin: theme.spacing(0, 1, 0, 0),
  },

  [`& .${classes.canadaLogo}`]: {
    height: '24px',
    marginBottom: theme.spacing(3),
  },

  [`& .${classes.langBtnContainer}`]: {
    marginRight: theme.spacing(1),
    borderRightWidth: '1px',
    borderRightStyle: 'solid',
    borderRightColor: theme.palette.divider,
  },

  [`&.${classes.contentShift}`]: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: `calc(${DRAWER_WIDTH}px)`,
  }
}));

const Footer = React.forwardRef((props, ref) => {
  const {t,i18n} = useTranslation();

  
  let dateString = document.getElementById("app_release_date").innerHTML;
  let date = "";
  try{
    date = formatDate(dateString,i18n.language,true);
  }catch(err){
    date="";
  }
  
  return (
    <Root
      className={clsx(classes.root, classes.footer, {
        [classes.contentShift]: props.open,
      })}
      ref={ref}
      tabIndex="-1"
    >
      <div className={classes.footerContainer}>
        <div className={classes.canadaLogo}>
          <img
            src={process.env.STATIC_URL + '/images/wmms.svg'}
            alt={t('site.footer.imageCaption')}
          />
        </div>
        <Typography variant="body2" color="textSecondary" component="p">
          {t('site.footer.dateModified')} {date}
        </Typography>
      </div>
    </Root>
  );
});
Footer.displayName="Footer";
Footer.propTypes={
  handleSaveBeforeLeave: PropTypes.func,
  open: PropTypes.bool,
}

export default Footer;